import { render, staticRenderFns } from "./regret.vue?vue&type=template&id=6f053618&"
import script from "./regret.vue?vue&type=script&lang=js&"
export * from "./regret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports